exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal__header{margin-bottom:1.375rem;padding:0 .75rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ModalHeader/ModalHeader.scss
// module id = 688
// module chunks = 0